export class MotDuMaire {
    mayor_name: any;
    thank_you_phrase: any;
    mayor_message: any;
    mayor_image: any;

    private errorMessage: string = "";

    constructor() { }

    canSend(): boolean {
        this.errorMessage = "";

        if (!this.mayor_name || this.mayor_name.toString().trim() === "") {
            this.errorMessage = "Le nom et prénoms du maire est requis.";
            return false;
        }

        if (!this.thank_you_phrase || this.thank_you_phrase.toString().trim() === "") {
            this.errorMessage = "Le texte de remerciement est requis.";
            return false;
        }

        if (!this.mayor_message || this.mayor_message.toString().trim() === "") {
            this.errorMessage = "Le mot du maire est requis.";
            return false;
        }

        // if (!this.mayor_image) {
        //     this.errorMessage = "La photo du maire est requise.";
        //     return false;
        // }

    

        return true;
    }

    getErrorMessage(): string {
        return this.errorMessage;
    }
}
